
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ie/promotions/new-taxi-insurance-with-telematics",
      function () {
        return require("private-next-pages/ie/promotions/new-taxi-insurance-with-telematics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ie/promotions/new-taxi-insurance-with-telematics"])
      });
    }
  